"use strict";import{IconLayers as e}from"../src/elements/IconLayers.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-icon-layers",e);
//# sourceMappingURL=sp-icon-layers.js.map
